function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Base from './base';
import ParticipantGroups from './participant_groups';
import ParticipantGroup from './participant_group';
import Person from './mixins/_person';
import { format } from 'date-fns';

var Participant = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Participant, _Base);

  function Participant() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Participant.prototype;

  _proto.initialize = function initialize() {
    _Base.prototype.initialize.apply(this, arguments);

    this.include(Person);
  };

  _proto.urlRoot = function urlRoot() {
    return '/api/participants';
  };

  _proto.groupIds = function groupIds() {
    var groups = this.get('groups').pluck('id');

    if (!groups.length) {
      groups.push(0);
    }

    return groups;
  }
  /*
   * accepts a ParticipantGroup
   * or an id and determines if the participant
   * is assigned to the corresponding group
   */
  ;

  _proto.assignedTo = function assignedTo(group) {
    return this.get('groups').get(group);
  };

  _proto.formattedRegisteredOn = function formattedRegisteredOn() {
    return format(new Date(this.get('created_at')), 'MM/dd/yyyy');
  };

  _proto.byLastName = function byLastName() {
    return this.fullName({
      reverse: true,
      delimeter: ', '
    });
  };

  _proto.parse = function parse(attrs) {
    /*
     * TODO come up with a convention for
     * parsing out associations from our api
     */
    attrs.groups = new ParticipantGroups(attrs.groups);
    return _Base.prototype.parse.apply(this, arguments);
  };

  _proto.assignToGroup = function assignToGroup(groupId) {
    var group = new ParticipantGroup({
      id: groupId
    });
    this.get('groups').add(group);
    return this.sync('create', this, {
      processData: true,
      data: {
        participant_group_id: groupId,
        participant_id: this.participantId
      },
      url: '/api/participant_participant_groups'
    });
  };

  _proto.removeFromGroup = function removeFromGroup(groupId) {
    var group = new ParticipantGroup({
      id: groupId
    });
    this.get('groups').remove(group);
    return this.sync('delete', this, {
      processData: true,
      data: {
        participant_group_id: groupId,
        participant_id: this.participantId
      },
      url: '/api/participant_participant_groups/-1'
    });
  };

  _createClass(Participant, [{
    key: "defaults",
    get: function get() {
      return {
        checked: false,
        groups: new ParticipantGroups([])
      };
    } // Eek! We need this as /api/participants returns *memberships* so `this.get('id')`
    // would be the membershipId, not the participantId as this can also be instantiated
    // elsewhere, with 'real' participants we need to handle both cases - defaulting to
    // the voter_id where present

  }, {
    key: "participantId",
    get: function get() {
      return this.has('voter_id') ? this.get('voter_id') : this.get('id');
    }
  }]);

  return Participant;
}(Base);

export { Participant as default };